const BONREE_EMAIL_REGEX = /^[^\s;]+@bonree\.com$/

// 中文分号、中英文逗号、空格等均属非法分隔符，产品规则仅允许英文分号 - By AICode
const ILLEGAL_SEPARATOR_REGEX = /[\w\d]+[；,，\s]+[\w\d]+/

// 校验邮箱列表：英文分号分隔合法，非法分隔符优先拦截并提示格式错误 - By AICode
export function validateBonreeEmailsValue(value) {
  if (!value) {
    return undefined
  }
  if (ILLEGAL_SEPARATOR_REGEX.test(value)) {
    return '请使用英文分号（;）分隔多个邮箱'
  }
  const emails = value.split(';').filter(Boolean)
  if (!emails.length) {
    return '请至少填写一个邮箱'
  }
  const invalid = emails.filter(e => !BONREE_EMAIL_REGEX.test(e))
  if (invalid.length > 0) {
    return '邮箱仅支持 @bonree.com 后缀'
  }
  return undefined
}

export function normalizeEmailList(value) {
  return value
    .split(';')
    .map(item => item.trim())
    .filter(Boolean)
    .join(';')
}
